<template>
  <v-list-item>
    <v-list-item-avatar :color="memberIconColor">
      <v-avatar :class="{ talking: member.talking, 'member-status': true }">
        <v-icon dark>mdi-{{ memberIcon }}</v-icon>
      </v-avatar>
    </v-list-item-avatar>
    <v-list-item-content>
      <v-list-item-title class="text-truncate">
        &lt;{{ member.num }}&gt; {{ member.name }}
      </v-list-item-title>
      <v-list-item-subtitle>
        <v-tooltip bottom v-if="isInvited">
          <template v-slot:activator="{ on }">
            <v-icon small color="primary" v-on="on" class="mr-1 invited">
              mdi-cellphone-information
            </v-icon>
          </template>
          {{ $t('confr.tooltip.isInvited') }}
        </v-tooltip>
        <v-tooltip bottom v-if="member.admin">
          <template v-slot:activator="{ on }">
            <v-icon small color="blue" v-on="on" class="mr-1 is-admin">
              mdi-account-key
            </v-icon>
          </template>
          {{ $t('confr.tooltip.isAdmin') }}
        </v-tooltip>

        <v-icon small>mdi-clock-outline</v-icon>
        {{callTime | formatTime}}
      </v-list-item-subtitle>
    </v-list-item-content>
    <v-list-item-action>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" icon small
                 color="orange darken-2"
                 @click="$emit('kick-member')">
            <v-icon small>mdi-close-circle</v-icon>
          </v-btn>
        </template>
        <span>{{ $t('confr.kick') }}</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" icon small
                 class="mute-icon"
                 :color="mutedIconColor"
                 @click="$emit('mute-member')">
            <v-icon small>mdi-{{ mutedIcon }}</v-icon>
          </v-btn>
        </template>
        <span>{{ $t('confr.mute') }}</span>
      </v-tooltip>
    </v-list-item-action>
  </v-list-item>
</template>

<script>
export default {
  name: 'conference-member',
  data () {
    return {
      callTime: 0
    }
  },
  props: {
    member: {
      type: Object,
      required: true
    }
  },
  timer: 'updateOnCallTime',
  mounted () { this.updateOnCallTime() },
  methods: {
    updateOnCallTime: function () {
      const now = Math.ceil(Date.now() / 1000)
      const start = Math.ceil(this.member.joinTime.getTime() / 1000)
      this.callTime = now - start
    }
  },
  computed: {
    isInvited: function () {
      return this.member.invited
    },
    mutedIcon: function () {
      return this.member.muted ? 'microphone-off' : 'microphone'
    },
    mutedIconColor: function () {
      return this.member.muted
        ? 'red lighten-1'
        : 'green lighten-3'
    },
    memberIcon: function () {
      if (this.member.muted) {
        return 'microphone-off'
      } else if (this.member.talking) {
        return 'account-voice'
      } else {
        return 'account-circle'
      }
    },
    memberIconColor: function () {
      if (this.member.muted) {
        return 'red lighten-1'
      } else if (this.member.talking) {
        return 'primary darken-1'
      } else {
        return 'green'
      }
    }
  }
}
</script>

<style scoped>
@keyframes talking {
  from {
    transform: scale(0.8);
  }

  to {
    transform: scale(1);
  }
}

.talking {
  animation-duration: 300ms;
  animation-name: talking;
  animation-iteration-count: infinite;
  animation-direction: alternate;
}
</style>
